<template>
  <div class="companies">
    <div class="question">
      {{ $t('promotions.companies_description') }}
      <tooltip :text="$t('promotions.companies_description_disclaimer')"></tooltip>
    </div>
    <ListMultiSelect :bank="companies" :selected="promotion.companies"
                     show-select-all show-unselect-all
                     :bank-title="$t('promotions.branch_companies').replace('{INVENTORY}', $to(inventory.name))"
                     :selected-title="$t('promotions.selected_branch_companies')"></ListMultiSelect>
  </div>
</template>

<script>
import ListMultiSelect from "@/components/tools/ListMultiSelect";

export default {
  name: "PromotionCompanies",

  components: { ListMultiSelect },

  props: {
    companies: Array,
    promotion: Object,
    inventory: Object
  }
}
</script>